import { CdrGrid as S } from "@rei/cedar";
import q from "@rei/landing-image-component";
import { LandingContentBlock as x } from "@rei/landing-content-block";
import { palettes as j } from "@rei/landing-palettes";
import { resolveComponent as i, openBlock as a, createBlock as c, normalizeClass as C, normalizeStyle as k, withCtx as m, createElementVNode as _, mergeProps as f, createCommentVNode as y, renderSlot as b, createElementBlock as p, resolveDynamicComponent as V, toDisplayString as P, createVNode as O, Fragment as H, renderList as T } from "vue";
const v = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [o, r] of n)
    t[o] = r;
  return t;
}, B = {
  name: "StoryComponent",
  components: {
    CdrGrid: S,
    LandingImageComponent: q,
    LandingContentBlock: x
  },
  props: {
    media: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    content: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    aspectRatio: {
      type: String,
      required: !1,
      default: "5/4"
    },
    objectFit: {
      type: String,
      required: !1,
      default: "cover"
    },
    storyType: {
      type: String,
      required: !1,
      default: "double"
    },
    storyStackPosition: {
      type: String,
      required: !1,
      default: "straight"
    },
    palette: {
      type: Object,
      required: !1,
      default: () => ({
        surface: "primary"
      })
    },
    dataLocationIndex: {
      type: Number,
      required: !0,
      default: 1
    }
  },
  data() {
    return {
      paletteVars: j(this.palette)
    };
  },
  computed: {
    cssVars() {
      var e;
      return {
        "--image-aspect-ratio": this.aspectRatio,
        "--image-object-fit": this.objectFit,
        ...(e = this.paletteVars) == null ? void 0 : e.cssSurfacePaletteVars()
      };
    },
    classComputed() {
      var o, r;
      const e = this.storyType ? `story--${this.storyType}` : "", n = this.storyStackPosition ? `story--${this.storyStackPosition}` : "", t = (o = this.palette) != null && o.surface && ((r = this.palette) == null ? void 0 : r.surface) !== "primary" ? "story--background-fill" : "";
      return [e, n, t];
    }
  }
}, F = {
  class: "story__container--media"
}, L = {
  class: "story__container--content"
};
function I(e, n, t, o, r, s) {
  const l = i("landing-image-component"), u = i("landing-content-block"), d = i("cdr-grid");
  return a(), c(d, {
    class: C(["story", ...s.classComputed]),
    style: k(s.cssVars),
    "data-location-index": t.dataLocationIndex
  }, {
    default: m(() => [_("div", F, [t.media && t.media.images ? (a(), c(l, f({
      key: 0,
      "data-ui": "story-media",
      "custom-classes": "story-media story__image"
    }, t.media), null, 16)) : y("", !0)]), _("div", L, [t.content ? (a(), c(u, f({
      key: 0
    }, t.content, {
      "data-ui": "story-content"
    }), null, 16)) : y("", !0), b(e.$slots, "content")])]),
    _: 3
  }, 8, ["class", "style", "data-location-index"]);
}
const N = /* @__PURE__ */ v(B, [["render", I]]);
const h = {
  level: "h2",
  alignText: "center"
}, R = {
  single: "",
  double: "landing-stories__stories--double",
  triple: "landing-stories__stories--triple"
}, G = {
  name: "StoriesComponent",
  components: {
    CdrGrid: S,
    StoryComponent: N
  },
  props: {
    headingSection: {
      type: Object,
      required: !1,
      default: () => h
    },
    stories: {
      type: Array,
      required: !1,
      default: () => []
    },
    aspectRatio: {
      type: String,
      required: !1,
      default: "5/4"
    },
    objectFit: {
      type: String,
      required: !1,
      default: "cover"
    },
    grid: {
      type: String,
      required: !1,
      default: "double"
    },
    storyStackPosition: {
      type: String,
      required: !1,
      default: "straight"
    },
    palette: {
      type: Object,
      required: !1,
      default: () => ({
        surface: "primary"
      })
    }
  },
  computed: {
    cssVars() {
      return {
        "--heading-section-align": this.computedHeading.alignText
      };
    },
    computedHeading() {
      return {
        ...h,
        ...this.headingSection
      };
    },
    computedClassStoryGrid() {
      var t, o;
      const e = this.grid ? R[this.grid] : "", n = (t = this.palette) != null && t.surface && ((o = this.palette) == null ? void 0 : o.surface) !== "primary" ? "landing-stories__background" : "";
      return ["landing-stories__stories", e, n];
    }
  }
}, z = {
  key: 0,
  class: "landing-stories__container--heading"
};
function D(e, n, t, o, r, s) {
  const l = i("story-component"), u = i("cdr-grid");
  return a(), p("div", {
    class: "landing-stories",
    style: k(s.cssVars)
  }, [s.computedHeading.text ? (a(), p("div", z, [(a(), c(V(s.computedHeading.level), {
    class: "landing-stories__heading-title",
    "data-ui": "landing-stories-heading-title"
  }, {
    default: m(() => [_("span", null, P(s.computedHeading.text), 1)]),
    _: 1
  }))])) : y("", !0), O(u, {
    class: C(s.computedClassStoryGrid)
  }, {
    default: m(() => [(a(!0), p(H, null, T(t.stories, (d, g) => (a(), c(l, {
      key: `story-${g}`,
      media: d.media,
      content: d.content,
      "aspect-ratio": t.aspectRatio,
      "object-fit": t.objectFit,
      "story-type": t.grid,
      "story-stack-position": t.storyStackPosition,
      palette: t.palette,
      "data-location-index": g + 1
    }, null, 8, ["media", "content", "aspect-ratio", "object-fit", "story-type", "story-stack-position", "palette", "data-location-index"]))), 128)), b(e.$slots, "story", {}, void 0, !0)]),
    _: 3
  }, 8, ["class"])], 4);
}
const M = /* @__PURE__ */ v(G, [["render", D], ["__scopeId", "data-v-3ecd5644"]]);
export {
  M as StoriesComponent,
  N as StoryComponent
};
